import { render, staticRenderFns } from "./BubbleActions.vue?vue&type=template&id=bd8b2300"
import script from "./BubbleActions.vue?vue&type=script&lang=js"
export * from "./BubbleActions.vue?vue&type=script&lang=js"
import style0 from "./BubbleActions.vue?vue&type=style&index=0&id=bd8b2300&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports